import React from "react";
import { Flex } from "@jsq/ds/core";
import { ChatInterface } from "../ChatInterface";
import { PromptView } from "../PromptView";
import { SideBar } from "../SideBar";
import { AnalyticsAIProvider, useAnalyticsAI } from "./context";
import * as styles from "./styles_vanilla.css";

export type AnalyticsAIProps = Readonly<{
  arenaId: number;
  userId: number;
}>;

const AnalyticsAIContent: React.FC = () => {
  const { view, conversationContext } = useAnalyticsAI();

  return (
    <Flex className={styles.wrapperContainer}>
      <Flex className={styles.sidebarContainer}>
        <SideBar />
      </Flex>
      {view === "query" && (
        <Flex justifyContent="center" flexGrow={1}>
          <PromptView />
        </Flex>
      )}
      {view === "chat" && <ChatInterface key={conversationContext.conversationId ?? "new"} />}
    </Flex>
  );
};

export const AnalyticsAI: React.FC<AnalyticsAIProps> = ({ arenaId, userId }) => {
  return (
    <AnalyticsAIProvider arenaId={arenaId} userId={userId}>
      <AnalyticsAIContent />
    </AnalyticsAIProvider>
  );
};
